function Benefit() {
  return (
    <div className="px-3">
      <div className="xl:max-w-[1362px] max-w-[834px] w-full mx-auto lg:sm:text-xl sm:text-base text-sm mb-[200px]">
        <div className="text-green xl:text-2xl text-xl font-semibold">TrueApex NFTs benefits</div>
        <div className="mt-4">
          <span className="text-secondary font-semibold">Exclusive Holder Reward:</span> 40% of the
          interest earned from investments in TrueApex Finance Protocol will be distributed to NFT
          holders. 5% of the interest earned from the protocol fee will also be given to NFT
          holders.
        </div>
        <div className="mt-2">
          <span className="text-secondary font-semibold">Airdrop:</span> Free tokens will be
          distributed to every eligible NFT holder. TrueApex NFT holders will be airdropped the
          TrueX token upon launch.
        </div>
        <div className="mt-2">
          <span className="text-secondary font-semibold">Potential for Appreciation:</span> As the
          TrueApex ecosystem grows and adoption increases, the value of owning an NFT is likely to
          increase significantly.
        </div>
        <div className="mt-2">
          <span className="text-secondary font-semibold">Whitelisting:</span> Future minting of free
          NFTs
        </div>
        <div className="mt-2">
          <span className="text-secondary font-semibold">Collateralization:</span> Use the TrueApex
          NFT to get a crypto loan
        </div>
        <div className="mt-2">
          <span className="text-secondary font-semibold">Early Access:</span> Owning an NFT gives
          you early access to new features, applications, and platforms that are built on top of the
          protocol.
        </div>
        <div className="mt-2">
          <span className="text-secondary font-semibold">VIP Pass:</span> There is a special private
          channel just for TrueApex NFT holders in Discord.{" "}
        </div>
        <div className="mt-2">
          <span className="text-secondary font-semibold">Community Engagement:</span> Owning a
          TrueApex NFT gives you access to a community of like-minded individuals who are interested
          in the decentralized web.{" "}
        </div>
      </div>
    </div>
  );
}

export default Benefit;
